import React from "react";
import { VehicleInformation } from "../data/VehInfo";
import './vehicles.css'
import VehCard from "./VehCard";


const VehicleList = ({ onSelect }) => {
    const vd = VehicleInformation().platforms;

    const content = Object.keys(vd).map((vehKey, j)=>{
        return(
            <VehCard key={j} enabled={vd[vehKey].enable} bgImg={vd[vehKey].image} id={vehKey} onClick={() => onSelect(vehKey)}/>
        )
    })

    return (
        <div className="vehicles">
            {content}
        </div>
    );
};

export default VehicleList;

   
